import Splide from '@splidejs/splide';

export default class Slider {
	static init() {
		Array.from(document.querySelectorAll('.slider')).forEach(element => {
			new Slider(element);
		});
	}

	constructor(element) {
        const options = {
            type: 'slide',
            rewind: true,
            lazyLoad: 'nearby',
            speed: 600,
            arrows: element.querySelectorAll('.splide__slide').length > 1,
            autoplay: element?.dataset.hasOwnProperty('autoplay'),
            pagination: element?.dataset.hasOwnProperty('pagination'),
            interval: 5000,
            keyboard: 'true',
            perPage: element?.dataset?.slidesPerPage ?? 3,
            gap: 56,
            breakpoints: {
                1199: {
                    gap: 40,
                },
                991: {
                    perPage: element?.dataset?.slidesPerPage ?? 2,
                    gap: 32,
                },
                767: {
                    perPage: element?.dataset?.slidesPerPage ?? 2,
                    gap: 24,
                },
                575: {
                    perPage: 1,
                    gap: 12,
                },
            }
        };

        switch(document.documentElement.lang) {
            case 'de':
                options.i18n = {
                    prev: 'Vorheriger Artikel',
                    next: 'Nächster Artikel',
                    first: 'Gehe zum ersten Artikel',
                    last: 'Gehe zum letzten Artikel',
                    slideX: 'Gehe zu Artikel %s',
                    pageX: 'Gehe zu Seite %s',
                    play: 'Autoplay starten',
                    pause: 'Autoplay pausieren',
                }
                break;
            case 'it':
                options.i18n = {
                    prev: 'Articolo precedente',
                    next: 'Prossimo articolo',
                    first: 'Vai al primo articolo',
                    last: 'Vai all\'ultimo articolo',
                    slideX: 'Vai all\'articolo %s',
                    pageX: 'Vai alla pagina %s',
                    play: 'Avvia autoplay',
                    pause: 'Metti in pausa autoplay',
                }
                break;
            default:
                options.i18n = {
                    prev: 'Previous article',
                    next: 'Next article',
                    first: 'Go to first article',
                    last: 'Go to last article',
                    slideX: 'Go to article %s',
                    pageX: 'Go to page %s',
                    play: 'Start autoplay',
                    pause: 'Pause autoplay',
                };
        }

		new Splide(element.querySelector('.splide'), options).mount();
	}
}
